export default "__VITE_ASSET__C$rupqGz__"